import { ROLES } from "containers/Permissions/roles";

export const ALL_USERS = []; // even those without organization
export const ALL_ORGANIZATION_MEMBERS = [ROLES.organization.member];
export const ALL_PROVIDERS = Object.values(ROLES.provider);
export const ALL_DISTRIBUTORS = [
  ROLES.distributor.readOnlyDistributionPlanner,
  ROLES.distributor.distributionPlanner,
  ROLES.distributor.restrictedDistributionPlanner,
];
export const ALL_DISTRIBUTION_PLANNERS = [
  ROLES.distributor.distributionPlanner,
  ROLES.distributor.restrictedDistributionPlanner,
];
export const ALL_MODERATORS = Object.values(ROLES.moderator);
export const ALL_TIVO = Object.values(ROLES.tivo);
